import { countOccupantsForFlights } from 'lib/offer/occupancyUtils'
import { defaultFareClass, FlightsFareTypes, FlightViewTypes } from 'constants/flight'
import { OFFER_TYPE_TOUR } from 'constants/offer'

const TOUR_FLIGHT_CUTOFF_TIME = '12:00'

const TOUR_FLIGHT_SEARCH_DEFAULTS = {
  fareClass: defaultFareClass,
  fareType: FlightsFareTypes.ONE_WAY,
  viewType: FlightViewTypes.ONE_WAY,
  source: OFFER_TYPE_TOUR,
} as const

/** Resolve local edits against the booked tour and the customer's default airport. */
export function buildTourFlightSearch(tourItems: Array<App.Checkout.TourV2Item>, homeAirportCode?: string, tourAirports?: App.Tours.FlightAirports, edits?: App.TourFlightSearchEdits) {
  const rooms = tourItems.map(item => item.occupancy)
  const occupancies = [countOccupantsForFlights(rooms)]
  const tour = tourItems[0]
  const startDate = tour?.startDate ?? ''
  const fareClass = edits?.fareClass ?? defaultFareClass

  return {
    departing: {
      ...TOUR_FLIGHT_SEARCH_DEFAULTS,
      fareClass,
      maxArrivalTime: TOUR_FLIGHT_CUTOFF_TIME,
      itinerary: [{
        departureAirport: edits?.departingHomeAirportCode ?? homeAirportCode ?? '',
        arrivalAirport: tourAirports?.arrivalAirportCode ?? '',
        departureDate: edits?.departingDate ?? startDate,
        arrivalDate: startDate,
      }],
      occupancies,
    },
    returning: {
      ...TOUR_FLIGHT_SEARCH_DEFAULTS,
      fareClass,
      minDepartureTime: TOUR_FLIGHT_CUTOFF_TIME,
      itinerary: [{
        departureAirport: tourAirports?.departureAirportCode ?? '',
        arrivalAirport: edits?.returningHomeAirportCode ?? homeAirportCode ?? '',
        departureDate: edits?.returningDate ?? tour?.endDate ?? '',
      }],
      occupancies,
    },
  }
}
